<template>
  <div
    class="threeViewer"
    style="background: linear-gradient(0deg, rgb(246, 250, 255) 10%, rgb(214, 224, 235) 70%);height: 100%;width: 100%;"
  >
    <div id="threeViewer" style="width:100%;height:100%">
      <div
        v-if="status === 'loading'"
        class="loading gou-flex-container gou-flex-row gou-flex-horiz-center gou-flex-verti-center"
        style="background: linear-gradient(0deg, rgb(246, 250, 255) 10%, rgb(214, 224, 235) 70%);height: 100%;width: 100%;"
      >
        <span>正在加载模型，请稍候...</span>
      </div>
    </div>
    <div id="iconBox" class="icon-box gou-flex-container gou-flex-row gou-flex-verti-center">
      <i v-if="!canDisplayEyesIcon" class="gjw-iconfont gjw-icon-icon_size-hide disabled" title="模型文件中不包含尺寸标注，无法显示" />
      <i
        v-if="canDisplayEyesIcon && !showDimension"
        class="gjw-iconfont gjw-icon-icon_size-visible"
        title="显示模型中的尺寸标注"
        @click="switchShowDimension(true)"
      />
      <i v-if="canDisplayEyesIcon && showDimension" class="gjw-iconfont gjw-icon-icon_size-hide" title="隐藏模型中的尺寸标注" @click="switchShowDimension(false)" />
    </div>
    <div
      v-if="!status || status === 'error'"
      class="noToken gou-flex-container gou-flex-column gou-flex-horiz-center gou-flex-verti-center"
    >
      <img src="@/assets/img/icon_3d.png">
      <span>暂不支持预览</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Viewer } from '@/core/threejs/viewer'

export default {
  props: {
    familyType: {
      type: Object,
      default() {
        return {}
      }
    },
    // 根据条件判断是否要渲染3d
    show: {
      type: Boolean,
      default: false
    },
    newThreeD: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      app: null,
      status: null,
      viewer: new Viewer(),
      showDimension: false,
      currentUuid: null
    }
  },
  computed: {
    ...mapGetters({
      currentResource: 'resourceDetail/currentResource',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
      inputParameters: 'resourceDetail/inputParameters',
      geometryData: 'resourceDetail/geometryData',
      parameterGeometryData: 'resourceDetail/parameterGeometryData'
    }),
    isNovaDesign() {
      return this.currentResource.platformCode === 'NOVA_DESIGN'
    },
    canDisplayEyesIcon() {
      const geometryData = this.geometryData || {}
      const nodes = geometryData.nodes ? geometryData.nodes : []
      return nodes.some((item) => { return item.type === 'dimension' })
    }
  },
  watch: {
    'familyType.uuid': {
      handler(newValue) {
        this.currentUuid = newValue
        this.calc3D(newValue)
      },
      immediate: true
    },
    show: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) return
        this.calc3D(this.currentUuid)
      }
    }
  },
  methods: {
    ...mapActions({
      loadGeometry: 'resourceDetail/loadGeometry',
      loadRfaGeometry: 'resourceDetail/loadRfaGeometry',
      loadGacGeometry: 'resourceDetail/loadGacGeometry',
    }),
    calc3D(uuid) {
      if (!this.show) { return }
      // 轮询时，若规格已经发生了变化，无需继续请求接口
      if (uuid !== this.currentUuid) {
        return
      }
      this.status = 'loading'
      try {
        if (this.isNovaDesign) {
          if (!this.newThreeD) {
            // 旧3D预览，走gcmpserver
            this.loadGeometry(
              {
                storeId: this.versionResourceInfo.storeId,
                inputParameters: this.inputParameters
              }
            ).then(() => this.loadViewer())
              .catch((err) => this.loadViewerError(err, uuid))
          } else {
            // 新3D预览，下载json文件
            this.loadGacGeometry(
              {
                coreReousrceId: this.versionResourceInfo.coreResourceId,
                coreReousrceVersionId: this.versionResourceInfo.coreResourceVersionId
              }
            ).then(() => this.loadViewer())
              .catch((err) => this.loadViewerError(err, uuid))
          }
        } else {
          // 新3D预览，下载json文件
          this.loadRfaGeometry(this.versionResourceInfo.coreResourceId)
            .then(() => this.loadViewer())
            .catch((err) => this.loadViewerError(err, uuid))
        }
      } catch (error) {
        this.status = 'error'
      }
    },
    loadViewer() {
      this.status = 'success'
      this.$nextTick(() => {
        if (JSON.stringify(this.geometryData) === '{}') {
          this.status = 'error'
          return
        }
        if (!this.show) { return }
        this.viewer.clear({ clearMount: true })
        this.viewer.init('threeViewer')
        this.viewer.loadGacJson(this.geometryData, this.showDimension)
      }, () => {
        this.status = 'error'
      })
    },
    loadViewerError(err, uuid) {
      if (err && err.status === 504) {
        // 循环调用此方法，直到接口数据返回正常
        this.calc3D(uuid)
      } else {
        this.status = 'error'
      }
    },
    // 是否显示标注
    switchShowDimension(bool) {
      this.showDimension = bool
      this.viewer.clear({ clearMount: true })
      this.viewer.init('threeViewer')
      if (this.resourcePlatform === 'gac') {
        this.viewer.loadGacJson(this.parameterGeometryData, bool)
      } else {
        this.viewer.loadGacJson(this.parameterGeometryData, false)
      }
    },
  },
}
</script>
<style lang="less" scoped>
  .threeViewer {
    position: relative;
    #threeViewer {
      height: 100%;
      width: 100%;
    }
    .icon-box {
      box-sizing: content-box;
      position: absolute;
      right: 14px;
      bottom: 14px;
      z-index: 99;
      width: 40px;
      height: 40px;
      padding: 10px;
      background: rgba(0, 0, 0, .5);
      .gjw-iconfont {
        font-size: 40px;
        color: #FFFFFF;
        cursor: pointer;
        &:not(.disabled):hover {
          color: #39E9DB;
        }
        &.disabled{
          opacity: 0.5;
          cursor: default;
        }
      }
    }
    .noToken,
    .loading {
      border-radius: 4px;
      background: #F5F5FA;
      text-align: center;
      font-size: 14px;
      vertical-align: middle;
      position: absolute;
      width: 100%;height: 100%;
      top: 0;left: 0;
    }
    .noToken {
      img {
        width: 400px;
        max-width: 100%;
      }
      span {
        position: relative;
        top: -80px;
      }
    }
    .viewer {
      position: absolute;
      .bf-container {
        border-radius: 4px;
      }
      .bf-toolbar-select[title=FamilyTypes] {
        display: none;
      }
    }
  }
</style>
